"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataValidatorService = void 0;
const XLSX = require("xlsx");
const validated_data_1 = require("../dto/validated-data");
const members_file_structure_1 = require("../dto/members-file-structure");
const string_utils_1 = require("./string-utils");
const register_status_enum_1 = require("../dto/register-status-enum");
const product_name_1 = require("../utils/product-name");
class DataValidatorService {
    assertHeaderFields(file) {
        const workbook = XLSX.read(file.buffer, { type: 'buffer' });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const stringUtils = new string_utils_1.StringUtils();
        members_file_structure_1.MEMBERS_FILE_STRUCTURE.forEach((field) => {
            var _a;
            const cell = field.cell;
            if (!stringUtils.areSimilar(field.columnName, (_a = worksheet[cell]) === null || _a === void 0 ? void 0 : _a.v) &&
                field.isRequiredInFile) {
                throw new Error(`Falta la columna ${cell} o es incorrecta. Se esperaba: ${field.columnName}`);
            }
        });
        return true;
    }
    isValidEmail(value) {
        if (typeof value !== 'string')
            return false;
        const emailRegex = /^[\w-.+]+@([\w-]+\.)+[a-zA-Z]{2,}$/;
        return emailRegex.test(value.trim());
    }
    isValidRfc(rfc) {
        if (typeof rfc !== 'string')
            return false;
        const rfcRegex = /^([A-ZÑ&]{4}\d{6}|[A-ZÑ&]{3,4}\d{6}[A-Z\d]{3})$/i;
        return rfcRegex.test(rfc.trim());
    }
    isValidPhone(phone) {
        if (typeof phone !== 'string' && typeof phone !== 'number')
            return false;
        const trimmed = phone.toString().trim();
        const mxLocalRegex = /^\d{10}$/;
        return mxLocalRegex.test(trimmed);
    }
    isValidProduct(product) {
        if (typeof product !== 'string')
            return false;
        const trimmed = product.trim();
        return (trimmed === product_name_1.ProductName.MM1.toString() ||
            trimmed === product_name_1.ProductName.MM2.toString());
    }
    isValidPaymentFrequency(paymentFrequency) {
        if (typeof paymentFrequency !== 'string')
            return false;
        const trimmed = paymentFrequency.trim();
        return trimmed === 'Mensual' || trimmed === 'Anual';
    }
    readFile(xlsFile) {
        const workbook = XLSX.read(xlsFile.buffer, { type: 'buffer' });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const data = [];
        let maxRow = 0;
        Object.keys(worksheet).forEach((cell) => {
            const regex = /([A-Z]+)(\d+)/;
            const match = regex.exec(cell);
            if (match) {
                const rowNum = parseInt(match[2], 10);
                if (rowNum > maxRow)
                    maxRow = rowNum;
            }
        });
        for (let rowIdx = 2; rowIdx <= maxRow; rowIdx++) {
            const columnsInfo = [];
            members_file_structure_1.MEMBERS_FILE_STRUCTURE.forEach((field) => {
                if (field.isRequiredInFile) {
                    const colLetters = field.cell.replace(/\d+/, '');
                    const cellRef = `${colLetters}${rowIdx}`;
                    const cellObj = worksheet[cellRef];
                    let columnValue = (cellObj === null || cellObj === void 0 ? void 0 : cellObj.v) != null ? String(cellObj.v) : '';
                    if (field.columnName ===
                        members_file_structure_1.MEMBERS_FILE_STRUCTURE[members_file_structure_1.MEMBER_COLUMNS_POSITION.LAST_NAME]
                            .columnName ||
                        field.columnName ===
                            members_file_structure_1.MEMBERS_FILE_STRUCTURE[members_file_structure_1.MEMBER_COLUMNS_POSITION.LAST_NAME_MOTHER]
                                .columnName ||
                        field.columnName ===
                            members_file_structure_1.MEMBERS_FILE_STRUCTURE[members_file_structure_1.MEMBER_COLUMNS_POSITION.FIRST_NAME]
                                .columnName ||
                        field.columnName ===
                            members_file_structure_1.MEMBERS_FILE_STRUCTURE[members_file_structure_1.MEMBER_COLUMNS_POSITION.RFC].columnName) {
                        columnValue = columnValue.toUpperCase();
                    }
                    if (field.columnName ===
                        members_file_structure_1.MEMBERS_FILE_STRUCTURE[members_file_structure_1.MEMBER_COLUMNS_POSITION.PRODUCT].columnName) {
                        const trimmedValue = columnValue.trim();
                        if (trimmedValue !== product_name_1.ProductName.MM1.toString() &&
                            trimmedValue !== product_name_1.ProductName.MM2.toString()) {
                            columnValue = '';
                        }
                    }
                    if (field.columnName ===
                        members_file_structure_1.MEMBERS_FILE_STRUCTURE[members_file_structure_1.MEMBER_COLUMNS_POSITION.PAYMENT].columnName) {
                        const trimmedValue = columnValue.trim();
                        if (trimmedValue !== 'Mensual' && trimmedValue !== 'Anual') {
                            columnValue = '';
                        }
                    }
                    columnsInfo.push({
                        columnName: field.columnName,
                        columnValue: columnValue.trim(),
                        isValid: true,
                        isRepeated: false,
                        type: field.type,
                        isVisible: field.isVisible,
                        isRequiredInFile: field.isRequiredInFile,
                    });
                }
            });
            if (columnsInfo.some((col) => col.columnValue !== null &&
                col.columnValue !== undefined &&
                col.columnValue !== '')) {
                data.push({
                    columns: columnsInfo,
                });
            }
        }
        return data;
    }
    validateMandatoryFields(data) {
        var _a;
        for (const row of data) {
            if (!row.columns)
                continue;
            if (((_a = row.columns[members_file_structure_1.MEMBER_COLUMNS_POSITION.STATUS]) === null || _a === void 0 ? void 0 : _a.columnValue) ===
                register_status_enum_1.RegisterStatus.LEGACY.toString()) {
                this.ignoreValidationForEntireRow(row);
            }
            else {
                for (const col of row.columns) {
                    if (col.isRequiredInFile) {
                        col.isValid =
                            col.columnValue !== undefined &&
                                col.columnValue !== null &&
                                col.columnValue !== '' &&
                                col.columnValue.trim() !== '';
                    }
                    else {
                        col.isValid = true;
                    }
                }
            }
        }
    }
    validateData(data) {
        this.validateMandatoryFields(data);
        this.validateIsolatedRecords(data);
        this.verifyRepeatedData(data);
    }
    ignoreValidationForEntireRow(dataRow) {
        var _a;
        (_a = dataRow.columns) === null || _a === void 0 ? void 0 : _a.forEach((field) => {
            field.isValid = true;
        });
    }
    validateIsolatedRecords(data) {
        data.forEach((dataRow) => {
            var _a, _b;
            if (((_a = dataRow.columns[members_file_structure_1.MEMBER_COLUMNS_POSITION.STATUS]) === null || _a === void 0 ? void 0 : _a.columnValue) ===
                register_status_enum_1.RegisterStatus.LEGACY.toString()) {
                this.ignoreValidationForEntireRow(dataRow);
            }
            else {
                (_b = dataRow.columns) === null || _b === void 0 ? void 0 : _b.forEach((field) => {
                    if (validated_data_1.ColumnType.EMAIL == field.type) {
                        field.isValid = this.isValidEmail(field.columnValue);
                    }
                    else if (validated_data_1.ColumnType.RFC == field.type) {
                        field.isValid = this.isValidRfc(field.columnValue);
                    }
                    else if (validated_data_1.ColumnType.PHONE == field.type) {
                        field.isValid = this.isValidPhone(field.columnValue);
                    }
                    else if (field.columnName ===
                        members_file_structure_1.MEMBERS_FILE_STRUCTURE[members_file_structure_1.MEMBER_COLUMNS_POSITION.PRODUCT].columnName) {
                        if (field.columnValue && field.columnValue.trim() !== '') {
                            const isValidProduct = this.isValidProduct(field.columnValue);
                            if (!isValidProduct) {
                                field.columnValue = '';
                            }
                            field.isValid = isValidProduct;
                        }
                        else {
                            field.isValid = false;
                        }
                    }
                    else if (field.columnName ===
                        members_file_structure_1.MEMBERS_FILE_STRUCTURE[members_file_structure_1.MEMBER_COLUMNS_POSITION.PAYMENT].columnName) {
                        if (field.columnValue && field.columnValue.trim() !== '') {
                            const isValidPaymentFrequency = this.isValidPaymentFrequency(field.columnValue);
                            if (!isValidPaymentFrequency) {
                                field.columnValue = '';
                            }
                            field.isValid = isValidPaymentFrequency;
                        }
                        else {
                            field.isValid = false;
                        }
                    }
                });
            }
        });
    }
    markRepeatedEmails(data) {
        this.markRepeatedField(data, validated_data_1.ColumnType.EMAIL);
        this.markOriginalRepeatedEmails(data);
    }
    markRepeatedRfc(data) {
        this.markRepeatedField(data, validated_data_1.ColumnType.RFC);
        this.markOriginalRepeatedRfc(data);
    }
    markRepeatedPhones(validatedData) {
        this.markRepeatedField(validatedData, validated_data_1.ColumnType.PHONE);
        this.markOriginalRepeatedPhones(validatedData);
    }
    markRepeatedField(validatedData, colunmType) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const groups = {};
        for (let i = 0; i < validatedData.length; i++) {
            const data = validatedData[i];
            const field = (_a = data.columns) === null || _a === void 0 ? void 0 : _a.find((col) => colunmType === col.type);
            const status = (_c = (_b = data.columns) === null || _b === void 0 ? void 0 : _b[members_file_structure_1.MEMBER_COLUMNS_POSITION.STATUS]) === null || _c === void 0 ? void 0 : _c.columnValue;
            const val = (_d = field === null || field === void 0 ? void 0 : field.columnValue) !== null && _d !== void 0 ? _d : '';
            if (!val)
                continue;
            if (!groups[val])
                groups[val] = { indices: [], legacyIndices: [], nonLegacyIndices: [] };
            groups[val].indices.push(i);
            if (status === register_status_enum_1.RegisterStatus.LEGACY.toString())
                groups[val].legacyIndices.push(i);
            else
                groups[val].nonLegacyIndices.push(i);
        }
        for (const group of Object.values(groups)) {
            const { indices, legacyIndices, nonLegacyIndices } = group;
            if (indices.length <= 1) {
                const idx = indices[0];
                const f = (_e = validatedData[idx].columns) === null || _e === void 0 ? void 0 : _e.find((c) => c.type === colunmType);
                if (f)
                    f.isRepeated = false;
                continue;
            }
            if (legacyIndices.length === 0) {
                const first = indices[0];
                for (const idx of indices) {
                    const f = (_f = validatedData[idx].columns) === null || _f === void 0 ? void 0 : _f.find((c) => c.type === colunmType);
                    if (!f)
                        continue;
                    f.isRepeated = idx !== first;
                }
                continue;
            }
            for (const idx of legacyIndices) {
                const f = (_g = validatedData[idx].columns) === null || _g === void 0 ? void 0 : _g.find((c) => c.type === colunmType);
                if (f)
                    f.isRepeated = false;
            }
            for (const idx of nonLegacyIndices) {
                const f = (_h = validatedData[idx].columns) === null || _h === void 0 ? void 0 : _h.find((c) => c.type === colunmType);
                if (!f)
                    continue;
                f.isRepeated = indices.length > 1;
            }
        }
        return validatedData;
    }
    verifyRepeatedData(data) {
        this.markRepeatedEmails(data);
        this.markRepeatedRfc(data);
        this.markRepeatedPhones(data);
        return data;
    }
    markOriginalRepeated(validatedData, columnType) {
        var _a, _b, _c, _d, _e, _f, _g;
        const groups = {};
        for (let i = 0; i < validatedData.length; i++) {
            const data = validatedData[i];
            const field = (_a = data.columns) === null || _a === void 0 ? void 0 : _a.find((col) => col.type === columnType);
            const status = (_c = (_b = data.columns) === null || _b === void 0 ? void 0 : _b[members_file_structure_1.MEMBER_COLUMNS_POSITION.STATUS]) === null || _c === void 0 ? void 0 : _c.columnValue;
            const val = (_d = field === null || field === void 0 ? void 0 : field.columnValue) !== null && _d !== void 0 ? _d : '';
            if (!val)
                continue;
            if (!groups[val])
                groups[val] = { indices: [], legacyIndices: [], nonLegacyIndices: [] };
            groups[val].indices.push(i);
            if (status === register_status_enum_1.RegisterStatus.LEGACY.toString())
                groups[val].legacyIndices.push(i);
            else
                groups[val].nonLegacyIndices.push(i);
        }
        for (const group of Object.values(groups)) {
            const { indices, legacyIndices, nonLegacyIndices } = group;
            for (const idx of indices) {
                const f = (_e = validatedData[idx].columns) === null || _e === void 0 ? void 0 : _e.find((c) => c.type === columnType);
                if (f)
                    f.isOriginalRepeated = false;
            }
            if (indices.length <= 1)
                continue;
            if (legacyIndices.length > 0 && nonLegacyIndices.length > 0) {
                const f = (_f = validatedData[legacyIndices[0]].columns) === null || _f === void 0 ? void 0 : _f.find((c) => c.type === columnType);
                if (f)
                    f.isOriginalRepeated = true;
                continue;
            }
            if (legacyIndices.length === 0 && nonLegacyIndices.length > 0) {
                const f = (_g = validatedData[indices[0]].columns) === null || _g === void 0 ? void 0 : _g.find((c) => c.type === columnType);
                if (f)
                    f.isOriginalRepeated = true;
                continue;
            }
        }
    }
    markOriginalRepeatedEmails(validatedData) {
        this.markOriginalRepeated(validatedData, validated_data_1.ColumnType.EMAIL);
    }
    markOriginalRepeatedRfc(validatedData) {
        this.markOriginalRepeated(validatedData, validated_data_1.ColumnType.RFC);
    }
    markOriginalRepeatedPhones(validatedData) {
        this.markOriginalRepeated(validatedData, validated_data_1.ColumnType.PHONE);
    }
}
exports.DataValidatorService = DataValidatorService;
//# sourceMappingURL=data-validator.service.js.map